import React from "react";
import { Controller } from "react-hook-form";
import { Col, FormGroup, Label } from "reactstrap";
import { useTranslation } from "react-i18next";
import { AntInput } from "@/CommonElements/AntInput";
import { Row } from "react-bootstrap";
import { Divider } from "antd";
import CaseDetails from "./CaseDetails";

function OtherReportTab({
  control,
  FormField,
  watch,
  threeCol,
  fullWidthCol,
  healthCertificateInputRef,
  existingDocuments = [],
  reportId = null,
}) {
  const { t } = useTranslation();

  return (
    <>
    <Row className="w-75">
      <FormField name="reported_person_name" label={t("FULL_NAME")} required colProps={{xs:12, sm:6}} errorInside>
        <Controller
          name="reported_person_name"
          control={control}
          rules={{ required: t("FIELD_REQUIRED") }}
          render={({ field, fieldState: { invalid, error } }) => (
            <>
              <AntInput
                {...field}
                status={invalid ? "error" : undefined}
                id="reported_person_name"
                placeholder={t("ENTER_PLACEHOLDER")}
              />
              {error && (
                <div className="text-danger small mt-1">{error.message}</div>
              )}
            </>
          )}
        />
      </FormField>
      <FormField name="reported_person_id_number" label={t("ID_NUMBER")} required colProps={{xs:12, sm:6}} errorInside>
        <Controller
          name="reported_person_id_number"
          control={control}
          rules={{ required: t("FIELD_REQUIRED") }}
          render={({ field, fieldState: { invalid, error } }) => (
            <>
              <AntInput
                {...field}
                status={invalid ? "error" : undefined}
                id="reported_person_id_number"
                placeholder={t("ENTER_PLACEHOLDER")}
              />
              {error && (
                <div className="text-danger small mt-1">{error.message}</div>
              )}
            </>
          )}
        />
      </FormField>
      <Col xs={12} md={6}>
        <FormGroup className="mb-3">
          <Label className="fw-bold" for="reported_person_phone_number">
            {t("MOBILE_NUMBER")} <span className="text-danger">*</span>
          </Label>
          <Controller
            name="reported_person_phone_number"
            control={control}
            rules={{ required: t("FIELD_REQUIRED") }}
            render={({ field, fieldState: { invalid, error } }) => (
              <>
                <AntInput
                  {...field}
                  status={invalid ? "error" : undefined}
                  id="reported_person_phone_number"
                  placeholder={t("ENTER_PLACEHOLDER")}
                />
                {error && (
                  <div className="text-danger small mt-1">{error.message}</div>
                )}
              </>
            )}
          />
        </FormGroup>
      </Col>
      <Col xs={12}>
        <Divider />
      </Col>
      </Row>
      <CaseDetails
        control={control}
        FormField={FormField}
        watch={watch}
        threeCol={threeCol}
        fullWidthCol={fullWidthCol}
        healthCertificateInputRef={healthCertificateInputRef}
        existingDocuments={existingDocuments}
        reportId={reportId}
      />
    </>
  );
}

export default OtherReportTab;
